import { Toaster, Position, IToaster } from '@blueprintjs/core';

export const DefaultToaster: IToaster = Toaster.create({
  position: Position.TOP,
});
